export default __webpack_public_path__ + "static/media/gallery_07.78d26dc2.jpg";